import { useStore } from '@/domain/state'
import { SideDrawer } from '@/domain/state/sideDrawer'
import { useEffect } from 'react'
import { useAccount } from './useAccount'

export function useSideDrawer(): SideDrawer {
  const { isOpen, activeTab, swapDialog, tokensTab, positionsTab, setActiveTab, setOpen, toggle, open, close } =
    useStore((state) => state.sideDrawer)

  const account = useAccount()

  useEffect(() => {
    if (!account) {
      setOpen(false)
    }
  }, [account, setOpen])

  return { isOpen, activeTab, swapDialog, tokensTab, positionsTab, setActiveTab, setOpen, toggle, open, close }
}
